import { Routes } from '@angular/router';
import { LtiLaunchComponent } from './pages/auth/lti-launch/lti-launch.component';
import { SigninComponent } from './pages/auth/signin/signin.component';
import { EditProfileComponent } from './pages/profiles/edit-profile/edit-profile.component';
import { authGuard } from './guards/auth.guard';
import { RootComponent } from './pages/root/root.component';
import { DebugComponent } from './pages/debug/debug.component';
import { AcceptInviteComponent } from './pages/accept-invite/accept-invite.component';

export const routes: Routes = [
    { path: '', component: RootComponent},
    { path: 'lti-launch', component: LtiLaunchComponent},
    { path: 'signin', component: SigninComponent},
    { path: 'invite/:inviteCode', component: AcceptInviteComponent},
    {
        path: 'admin',
        loadChildren: () =>
          import('./pages/admin/admin.routes')
            .then(m => m.ADMIN_ROUTES)
    },
    {
        path: 'student',
        loadChildren: () =>
          import('./pages/student/student.routes')
            .then(m => m.STUDENT_ROUTES)
    },
    {
        path: 'edit-profile', component: EditProfileComponent, canActivate: [authGuard]
    },
    {
        path: 'take-selfie',
        loadComponent: () =>
          import('./pages/profiles/take-selfie/take-selfie.component')
            .then(m => m.TakeSelfieComponent),
            canActivate: [authGuard]
    },
    {
        path: 'request-selfie/:requestId',
        loadComponent: () =>
          import('./pages/profiles/request-selfie/request-selfie.component')
            .then(m => m.RequestSelfieComponent),
            canActivate: [authGuard]
    },
    {
      path: 'selfie-requests/:requestId',
      loadComponent: () =>
        import('./pages/profiles/take-selfie/take-selfie.component')
          .then(m => m.TakeSelfieComponent)
    },
    {
      path: 'debug',
      component: DebugComponent, canActivate: [authGuard]
    }
];
